'use strict';

require('../shared/base-entry');
require('./views/exclusive-offers');
require('../shared/post-entry');
